window.BAO.carousel = {
  useInitialised () {
    /** @param {import('keen-slider').KeenSliderInstance} carousel */
    return carousel => {
      carousel.on('created', carousel => {
        carousel.container.setAttribute('data-initialised', true)
      })
      carousel.on('destroyed', carousel => {
        carousel.container.removeAttribute('data-initialised')
      })
    }
  },

  /**
   * @param {{
   *  next?: HTMLButtonElement,
   *  previous?: HTMLButtonElement,
   * }} elements
   */
  useArrows ({ next, previous } = {}) {
    /** @param {import('keen-slider').KeenSliderInstance} carousel */
    return carousel => {
      next?.addEventListener('click', carousel.next)
      previous?.addEventListener('click', carousel.prev)

      const updateButtonStates = () => {
        const { abs, maxIdx, min } = carousel.track.details

        if (next) {
          next.disabled = abs === maxIdx
          next.setAttribute('aria-hidden', (maxIdx === 0).toString())
        }

        if (previous) {
          previous.disabled = abs === min
          previous.setAttribute('aria-hidden', (maxIdx === 0).toString())
        }
      }

      carousel.on('created', updateButtonStates)
      carousel.on('slideChanged', updateButtonStates)
    }
  },

  /**
   * @param {number} seconds
   * @param {{
   *  pauseOnHover?: boolean
   * }} options
   */
  useAutoplay (seconds = 2, { pauseOnHover = true } = {}) {
    const delay = seconds * 1000

    /** @param {import('keen-slider').KeenSliderInstance} carousel */
    return carousel => {
      let timeout
      let mouseOver = false

      const clearCurrentTimout = () => clearTimeout(timeout)
      const setNextTimeout = () => {
        clearCurrentTimout()

        if (mouseOver) {
          return
        }

        timeout = setTimeout(carousel.next, delay)
      }

      carousel.on('created', () => {
        if (pauseOnHover) {
          carousel.container.addEventListener('mouseover', () => {
            mouseOver = true
            clearCurrentTimout()
          })
          carousel.container.addEventListener('mouseout', () => {
            mouseOver = false
            setNextTimeout()
          })
        }

        setNextTimeout()
      })

      carousel.on('dragStarted', clearCurrentTimout)
      carousel.on('animationEnded', setNextTimeout)
      carousel.on('updated', setNextTimeout)
    }
  },

  /** @param {HTMLButtonElement[]} dots */
  useDots (dots = []) {
    /** @param {import('keen-slider').KeenSliderInstance} carousel */
    return carousel => {
      const updateDotStates = () => {
        dots.forEach((dot, index) => {
          const isCurrent = carousel.track.details.rel === index

          dot.setAttribute('aria-current', String(isCurrent))
        })
      }

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          carousel.moveToIdx(index)
        })
      })

      carousel.on('created', updateDotStates)
      carousel.on('slideChanged', updateDotStates)
    }
  },

  /** @param {HTMLButtonElement[]} dots */
  useReveal (slides = []) {
    /** @param {import('keen-slider').KeenSliderInstance} carousel */
    return carousel => {
      carousel.on('created', () => {
        if (slides.length > 1) {
          slides[0].classList.add('util-Slide_Reveal')
          slides[1].classList.add('util-Slide_Reveal')

          slides[0].addEventListener('animationend', () => {
            slides[0].classList.remove('util-Slide_Reveal')
            slides[1].classList.remove('util-Slide_Reveal')
          }, { once: true })
        }
      })
    }
  },
}
